import { withProps } from 'recompose'
import { Field } from 'formik'
import { TextField } from 'formik-material-ui'

export default withProps({ component: TextField })(Field)
